// extracted by mini-css-extract-plugin
export default {"root":"HorizontalRule-root-a6cdc1d64003eb06d1505c8b23d2fb4d"};